import { Dispatch, SetStateAction, useState } from 'react';

import ModalWrappedContent from '@/components/basicComponents/modal/modalWrappedContent';
import Input from '@/components/basicComponents/input';
import styled from 'styled-components';
import { IListData } from '../types';

interface CreateStrategyProps {
  isOpen: boolean;
  preFillValue: string;
  setStrategies: Dispatch<SetStateAction<IListData>>;
  onClose: () => void;
}

const CreateStrategy = ({ isOpen, preFillValue, setStrategies, onClose }: CreateStrategyProps) => {
  const [value, setValue] = useState(preFillValue || '');

  const handleCloseDialog = () => {
    setStrategies((prev) => ({ ...prev, preFillValue: '' }));
    onClose();
  };

  const saveValue = () => {
    setStrategies((prevStrategies) => {
      if (!prevStrategies.list.includes(value)) {
        return { ...prevStrategies, list: [...prevStrategies.list, value] };
      }
      return prevStrategies;
    });

    setStrategies((prevStrategies) => {
      if (!prevStrategies.list.length) {
        return {
          ...prevStrategies,
          chosen: [...new Set([...prevStrategies.chosen, value])]
        };
      }

      let duplicateStrategy = '';

      const updatedChosenStrategies = prevStrategies.chosen.map((chosenStrategy) => {
        if (chosenStrategy === '') {
          return value;
        }
        if (chosenStrategy === value) {
          duplicateStrategy = value;
          return value;
        }
        return chosenStrategy;
      });

      return { ...prevStrategies, chosen: updatedChosenStrategies, duplicate: duplicateStrategy || null };
    });

    setTimeout(() => {
      setStrategies((prevStrategies) => {
        return {
          ...prevStrategies,
          duplicate: null,
          chosen: [...new Set(prevStrategies.chosen)]
        };
      });
    }, 1000);
    handleCloseDialog();
  };

  return (
    <ModalWrappedContent
      isOpen={isOpen}
      onClose={handleCloseDialog}
      title="Create New Sector"
      confirmButton={{
        name: 'Save',
        onClick: saveValue,
        disabled: !value.length
      }}
      showRequiredFields
    >
      <ModalDescription>Use sectors to categorize investments by sector or other dimensions useful for investor allocation.</ModalDescription>
      <ManagerInputWrap>
        <Input label="Sector" placeholder="Provide a Sector" value={value} onChange={(e) => setValue(e.target.value)} isRequiredField autoFocus />
      </ManagerInputWrap>
    </ModalWrappedContent>
  );
};

export default CreateStrategy;

const ModalDescription = styled.div`
  font-size: 19px;
  line-height: 27px;
  text-align: center;
  color: ${({ theme }) => theme.font.base};
`;

const ManagerInputWrap = styled.div`
  padding-top: 35px;
`;
